import { useCallback } from 'react';

import { tokenStorage } from 'api/client/helpers/tokenStorage';
import { useLoginByToken as useLoginByTokenApi } from 'api/requests';
import { ROUTES, useNavigate } from 'libs/navigation';

export const useLoginByToken = () => {
  const { navigate } = useNavigate();

  const { loading, data, error, login } = useLoginByTokenApi();

  const loginByToken = useCallback(
    async (token: string) => {
      const loginData = await login(token);

      if (loginData) {
        tokenStorage.login(loginData);
        if (!loginData.refreshToken) {
          navigate(ROUTES.setPassword.fullPath, {}, { replace: true });
          return;
        }
        window.location.replace(ROUTES.setPassword.fullPath);
      } else {
        throw Error();
      }
    },
    [login, navigate]
  );

  return {
    loginByToken,
    error,
    data,
    loading,
  };
};
